import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
  NumberField,
  ReferenceManyField,
  Datagrid,
} from 'react-admin';

export const CharacteristicGroupShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="slug" />
      <TextField source="description" />
      <NumberField source="sortOrder" />
      
      <ReferenceManyField reference="characteristics" target="groupId" label="Characteristics">
        <Datagrid>
          <TextField source="name" />
          <TextField source="slug" />
          <TextField source="unit" />
          <NumberField source="sortOrder" />
          <BooleanField source="isActive" />
        </Datagrid>
      </ReferenceManyField>
      
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);
